import { LIMIT_OF_CHARACTERS } from '~/shared/constants';
import { validate, validator } from '~/shared/helpers/validation-helpers';

const getDialogFormConfig = ({ t }: { t: (key: string, options: { ns: string[] }) => string }) => {
  const validation = validator({ t });

  return {
    name: 'dialog',
    pattern: 'basicFormPattern',
    position4: {
      formFields: [
        {
          name: 'text',
          label: t('field.message.title'),
          validate: validate([
            validation.required,
            validation.isInRange.bind(null, {
              min: LIMIT_OF_CHARACTERS.MESSAGE.MIN,
              max: LIMIT_OF_CHARACTERS.MESSAGE.MAX,
            }),
          ]),
          type: 'text-area',
          config: {
            isRow: true,
            isAutoFocus: true,
          },
        },
      ],
      buttons: [
        {
          name: 'submit',
          htmlType: 'submit',
          className: 'action-button--yellow action-button--full-width',
          buttonName: t('button.send'),
        },
      ],
    },
  };
};

export default getDialogFormConfig;
